module.exports = __webpack_public_path__ + "img/ceping64_xp.07857837.png";